import React from 'react';
import ReactDOM from 'react-dom';
import DropzoneComponent from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import '../../../scss/dropzone.scss';
import Resource from '../../services/Resource';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

/**
 * What you should know about this legacy component:
 *
 *   1. Variable called "file" may contain both: DOM element
 *      {HTMLAnchorElement} or file itself {Blob}.
 *      In case of HTMLAnchorElement it also contains some meta
 *      information:
 *       {
 *         lastModified : 1519042097082
 *         lastModifiedDate : 'Mon Feb 19 2018 14:08:17 GMT+0200 (EET)
 *         name : "MBMCS1g5ytYjb0e.jpg"
 *         processing : true
 *         size : 48052
 *         status : "success"
 *         type : "image/jpeg"
 *         upload : {progress: 100, total: 48250, bytesSent: 48250}
 *       }

 *   2. "defaultFiles" means previously uploaded files.
 *      eg you try to edit some form and it contains some
 *      old file items.
 *
 *   @see https://github.com/felixrieseberg/React-Dropzone-Component
 */
class FileUpload extends React.Component {

    constructor(props) {
        super(props);

        let {
            maxFilesize = props.type === 'file' ? MAX_FILE_SIZE : MAX_IMAGE_SIZE,
            uploadMultiple = true,
            maxFiles = 5,
            paramName = props.type === 'file' ? 'files' : 'images',
            postUrl = props.type === 'file' ? 'article/validate-files' : 'article/validate-images',
            dropzoneId = props.dropzoneId || '',
            dictDefaultMessage = props.intl.formatMessage(messages.filesSelectOrDrug),
            maxLimit = (maxFilesize > 1) ? maxFilesize - 1 : 1,
            //cannot use a translation for this line
            dictFileTooBig = "Filen er for stor ({{filesize}} MB). Maksimal filstørrelse: " + maxLimit + " MB.",
            dictInvalidFileType = props.intl.formatMessage(messages.filesErrorCantUploadThisFile),
            dictCancelUpload = props.intl.formatMessage(messages.filesCancelUpload),
            dictCancelUploadConfirmation = props.intl.formatMessage(messages.filesAreYouSureCancelUpload),
            dictRemoveFile = props.type === 'file' ?
                props.intl.formatMessage(messages.filesRemoveFile) :
                props.intl.formatMessage(messages.filesRemoveImage),
            dictMaxFilesExceeded = props.intl.formatMessage(messages.filesCantUploadMore)
        } = props;

        // Defines a group of images to be shown in a specific dropzone component in a form,
        // if the form contains several dropzones with type:"image"
        this.dropzoneId = dropzoneId;

        if (this.props.files === undefined) {
            this.inputs = {
                defaultFiles: eval('this.props.defaultImages' + dropzoneId),
                defaultFilesIds: eval('this.props.defaultImageIds' + dropzoneId),
                files: eval('this.props.images' + dropzoneId)
            };
        } else {
            this.inputs = {
                defaultFiles: this.props.defaultFiles,
                defaultFilesIds: this.props.defaultFileIds,
                files: this.props.files
            };
        }

        // For a full list of possible configurations,
        // please consult http://www.dropzonejs.com/#configuration
        this.djsConfig = {
            addRemoveLinks: uploadMultiple,
            acceptedFiles: props.type === 'file' ? [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                '.zip',
                '.xls',
                '.xlsx',
                'text/plain',
            ].join(',') : "image/jpeg,image/png,image/gif",
            maxFilesize: maxFilesize,
            uploadMultiple: uploadMultiple,
            maxFiles: maxFiles,
            paramName: paramName,
            dictDefaultMessage: dictDefaultMessage,
            dictFileTooBig: dictFileTooBig,
            dictInvalidFileType: dictInvalidFileType,
            dictCancelUpload: dictCancelUpload,
            dictCancelUploadConfirmation: dictCancelUploadConfirmation,
            dictRemoveFile: dictRemoveFile,
            dictMaxFilesExceeded: dictMaxFilesExceeded
        };

        this.componentConfig = {
            iconFiletypes: props.type === 'file' ? ['.pdf', '.zip', '.txt', '.doc'] : ['.jpg', '.png', '.gif', 'jpeg'],
            showFiletypeIcon: true,
            postUrl: `${Resource.prefix()}/${postUrl}`,
        };

        this.success = file =>  {
            this.passAcceptedFilesToForm();
        };

        this.removedfile = file => {
            this.passAcceptedFilesToForm();

        };

        this.dropzone = null;
    }

    passAcceptedFilesToForm() {
        let defaultFileIds  = [];
        let defaultFiles    = [];
        let uploadedFiles   = [];

        this.dropzone.getAcceptedFiles().forEach(function (file) {
            if(file.id) {
                defaultFileIds.push(file.id);
                return;
            }

            uploadedFiles.push(file);
        });

        defaultFiles = this.inputs.defaultFiles.input.value.filter(file => defaultFileIds.indexOf(file.id) !== -1);

        if(this.props.defaultFiles === undefined) {
            eval('this.props.defaultImages' + this.dropzoneId).input.onChange(defaultFiles);
            eval('this.props.defaultImageIds' + this.dropzoneId).input.onChange(defaultFileIds);
        } else {
            this.props.defaultFiles.input.onChange(defaultFiles);
            this.props.defaultFileIds.input.onChange(defaultFileIds);
        }

        let promises = uploadedFiles.map(function (file) {
            return this.createBlobFileFromMeta(file)
        }.bind(this));

        if(promises.length) {
            this.filesPromise = Promise.all(promises)
                .then(function (blobFile) {
                    return blobFile;
                });

            this.filesPromise.then(function (blobFiles) {
                if(this.props.files === undefined) {
                    eval('this.props.images' + this.dropzoneId).input.onChange(blobFiles);
                } else {
                    this.props.files.input.onChange(blobFiles);
                }
                this.filesPromise = null;
            }.bind(this));
        }
        else {
            if(this.filesPromise) {
                this.filesPromise.then(function (files) {
                    this.props.files.input.onChange([]);
                    this.filesPromise = null;
                }.bind(this));
            }
        }

    }

    createBlobFileFromMeta(fileElement) {
        return new Promise(function(resolve, reject){
            let reader = new FileReader();
            reader.onload = function(e) {
                let blobFile = new Blob([reader.result], {
                    type: fileElement.type,
                    lastModified: fileElement.lastModified,
                });

                blobFile.filename = fileElement.name;
                resolve(blobFile);
            };

            reader.onerror = function(error){
                reject(error);
            };

            reader.readAsArrayBuffer(fileElement);
        });
    }

    clearJustDownloadedFiles() {
        this.dropzone.files.forEach((file) => {
            if(file.id) {
                return;
            }

            this.inputs.defaultFiles.input.value.forEach(defaultFile => {
                let filesEqual = file.name == `${defaultFile.original_name}.${defaultFile.ext}`
                    && defaultFile.type === file.type
                    && defaultFile.size === file.size + 2;

                if(filesEqual) {
                    this.dropzone.removeFile(file)
                }
            })
        });
    }

    removeExtraFiles() {
        this.dropzone.files.forEach((file) => {
            if(!file.id) {
                return;
            }

            if(this.inputs.defaultFilesIds.input.value.indexOf(file.id) === -1) {
                this.dropzone.removeFile(file);
            }

        });
    }

    fileAlreadyInDropzone(file) {
        if(!file.id) {
            return false;
        }

        return !!this.dropzone.files.find(dropzoneFile => file.id == dropzoneFile.id);
    }

    updateDefaultFiles() {
        if(this.dropzone && this.inputs.defaultFiles.input.value) {
            this.removeExtraFiles();

            if(this.props.defaultFiles === undefined) {
                let defImages = eval('this.props.defaultImages' + this.dropzoneId);
                defImages.input.value.forEach((item, idx) => {
                    if(this.fileAlreadyInDropzone(item)) {
                        return;
                    }

                    let mockFile = {
                        name: item.original_name,
                        size: item.size,
                        type: item.type,
                        accepted: true,
                        id: item.id,
                    };

                    this.dropzone.emit('addedfile', mockFile);
                    this.dropzone.emit('complete', mockFile);
                    this.dropzone.emit("thumbnail", mockFile, this.dropzone.createThumbnailFromUrl(mockFile, item.path));

                    this.dropzone.files.push(mockFile);
                });
            } else {
                this.props.defaultFiles.input.value.forEach((item, idx) => {
                    if(this.fileAlreadyInDropzone(item)) {
                        return;
                    }

                    let mockFile = {
                        name: item.original_name,
                        size: item.size,
                        type: item.type,
                        accepted: true,
                        id: item.id,
                        path: item.path,
                    };

                    this.dropzone.emit('addedfile', mockFile);
                    this.dropzone.emit('complete', mockFile);

                    this.dropzone.files.push(mockFile);
                });
            }

            this.clearJustDownloadedFiles();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateDefaultFiles();
    }

    componentDidMount(prevProps, prevState) {
        this.updateDefaultFiles();
    }

    render() {
        const config    = this.componentConfig;
        const djsConfig = this.djsConfig;

        const eventHandlers = {
            init: dz => {
                this.dropzone = dz;
            },
            success: this.success,
            removedfile: this.removedfile,
            addedfile: (file) => {
                if(file.path) {
                    let a = document.createElement('a');
                    a.setAttribute('href', file.path);
                    a.classList.add("dz-remove");
                    a.innerHTML = "Download";
                    file.previewTemplate.appendChild(a);
                }
            },
        };

        return <div data-cy-upload={this.props.type}>
            <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig} />
        </div>
    }
};

export default injectIntl(FileUpload);


// WEBPACK FOOTER //
// ./web/src/components/files/FileUpload.jsx